/**
 * Whether an avatar value is something an <img> can actually render.
 *
 * The old check was `avatar.includes("http")`, which quietly dropped the
 * preview whenever a user picked a new photo: FileReader hands back a
 * `data:` URL, that string contains no "http", so the UI fell back to the
 * name's initial and the freshly chosen picture never appeared. Blob URLs
 * would have failed the same way.
 *
 * "default-avatar.png" is the backend's placeholder for "no picture", and is
 * treated as no image rather than a broken one.
 */
export const hasAvatarImage = (avatar?: string | null): boolean =>
  !!avatar &&
  avatar !== "default-avatar.png" &&
  /^(https?:|data:|blob:)/.test(avatar);
